import React from 'react';
export default ({item, label}) => (
  <div className="targetinfo">
    { item.gendermale > 0 &&
    <span>
      { label &&  <span>{label}: </span> }
      <span>{item.gendermale}% man</span>,&nbsp;
      <span>{item.genderfemale}% kvinna</span> 
    </span>
  }
  </div>

);



// WEBPACK FOOTER //
// ./src/components/Formaters/GenderInfo.jsx